import { useCallback, useEffect } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { batch, useSignal } from "@preact/signals-react"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"
import { reportFormDataInnit, reportFormNumSearches } from "Pages/ReportsAlerts/Reports/@signals"

export default function useForceReport(idReport) {
	const { backendUrl } = useReportBackendApiPath()
	const isLoading = useSignal(false)

	const setIsLoading = () => isLoading.value = true

	const onForce = useCallback(() => {
		isLoading.value = true
		getSubmit(`${backendUrl}/list`, { id: idReport })
			.then(data => batch(() => {
				reportFormDataInnit({ ...data, title: `Edit: ${data.name}` })
				reportFormNumSearches.value = data.numSearches
				isLoading.value = false
			}))
	}, [idReport])

	useEffect(() => {
		if (isLoading.value) onForce()
	}, [isLoading.value])

	return {
		setIsLoading,
		isLoading: isLoading.value
	}

}